import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

const BasicDataTable = ({
  tableData,
  TableColumns,
  tableoptions,
  rowStyle,
  sizePerPage,
}) => {
  //  No Data Image
  const NoDataIndication = () => (
    <div className="test">
      <div className="empty-state">
        <div className="empty-icon">📊</div>
        <h3>No Data Available</h3>
        <p>Adjust your filters or check back later for trading results</p>
      </div>
    </div>
  );

  const options = {
    sizePerPage: sizePerPage ? sizePerPage : 10,
    hidePageListOnlyOnePage: false,
    ...tableoptions,
  };

  return (
    <>
      <div className="table-responsive">
        <BootstrapTable
          keyField="id"
          data={tableData}
          columns={TableColumns}
          pagination={paginationFactory(options)}
          noDataIndication={() => <NoDataIndication />}
          headerClasses="text-center header-class "
          rowClasses={`text-center ${rowStyle}`}
        />
      </div>
    </>
  );
};

export default BasicDataTable;
